import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Component, Input, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Subscription } from 'rxjs';

import { AdvertisementsService } from '../../common/services/advertisements.service';
import { AppStore } from '../../common/stores/app.store';
import { AssetsService } from '../../common/services/assets.service';
import { Bus } from '../../common/services/bus';
import { MessagesService } from '../../common/services/messages.service';
import { NotificationsService } from '../../common/services/notifications.service';
import { SettingsService } from '../../common/services/settings.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { VideoOverlayComponent } from '../video-overlay/video-overlay.component';

@Component({
  selector: 'app-frames',
  templateUrl: './frames.component.html',
  styleUrls: ['./frames.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FramesComponent implements OnInit, OnDestroy {

  messages = [];
  cachedMessages = [];
  rooms = [];
  debugMessage: any;
  public advertisements = [''];
  public currentMessage: any;
  public scheduledMessage: any;
  public nextMessage: any;
  public qrCodeUrl: string;
  public isOnDemandMode = this.store.isOnDemand;
  public autoRotationInterval = this.store.autoRotationInterval || 0;
  public posterIdInput: string;
  public navigationDisabled = this.store.navigationDisabled;
  timeLeft: number;

  // private currentIndex: number;
  private timeout;
  private notificationsSub: Subscription;
  private settingsSub: Subscription;
  private roomId: number;

  constructor(
    private route: ActivatedRoute,
    private service: MessagesService,
    private adService: AdvertisementsService,
    private assets: AssetsService,
    private notificationsService: NotificationsService,
    private settingsService: SettingsService,
    private toastr: ToastrService,
    private bus: Bus,
    private store: AppStore,
    private location: Location,
    private dialog: MatDialog) {
    this.roomId = parseInt(this.route.snapshot.params['id'], 10);
    this.posterIdInput = this.store.posterId || '';
  }

  ngOnInit() {
    this.subscribe();
    this.load();
    this.findAndSetCurrentMessageById();
  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  load() {

    this.messages = this.route.snapshot.data.messages.slice();
    this.cachedMessages = this.route.snapshot.data.messages.slice();

    this.showNext();

    // this.service.sessions().toPromise().then( data => {
    //   this.messages = data.slice();
    //
    //   // Keep a copy of all sessions that will be used for navigating between
    //   // sessions using the "Next" and "Previous" buttons
    //   this.cachedMessages = data.slice();
    //
    //   this.showNext();
    // });

    this.adService.advertisements().toPromise().then( data => {
      this.advertisements = data;
      console.log('advertisements', this.advertisements);
    });
  }

  subscribe() {
    this.notificationsSub = this.notificationsService.get()
      .subscribe(notifications => {
        this.showNotification(notifications);
      });

    this.settingsSub = this.settingsService.getRefresh()
      .subscribe(forceRefresh => {
        if (forceRefresh) {
          clearTimeout(this.timeout);
          this.load();
        }
      });
  }

  unsubscribe() {
    this.notificationsSub.unsubscribe();
    this.settingsSub.unsubscribe();
  }

  reloadMessages() {
    this.service.sessions(true).toPromise().then( data => {
      this.messages = data.slice();
      this.cachedMessages = data.slice();
    });
  }

  // Works only with a sorted array of items
  private showNext() {
    const emptyCurrentMessage = {
      uuid: [{ value: -1}],
      nid: [{value: -1}],
      // field_mt_ses_files: [{ url: '../assets/placeholder-html.html'}],
      field_mt_ses_files: [{ url: this.location.prepareExternalUrl('assets/placeholder-html.html')}],
      field_mt_ses_abstract_id: [{ value: ''}],
      title: [{ value: ''}],
      field_mt_presentation_url: []
    };

    const message = this.messages.shift();
    this.currentMessage = this.currentMessage || emptyCurrentMessage;
    this.scheduledMessage = message;
    if (!message) {
      if (this.autoRotationInterval > 0) {
        this.scheduledMessage = this.cachedMessages[0];
        this.scheduledMessage.start_timestamp = Date.now() + this.autoRotationInterval;
        this.scheduledMessage.end_timestamp = this.scheduledMessage.start_timestamp + this.autoRotationInterval;
        setTimeout( () => {
          this.reloadMessages();
          this.resume();
        }, this.autoRotationInterval);
      }
      return;
    }
    if (this.isOnDemandMode) {
      this.currentMessage = this.scheduledMessage;
      return;
    }
    const delay = this.calcIntervalForMessage(message);

    // Check if delay exceeds the maximum allowed delay value for setTimeout()
    this.timeLeft = delay > 2147483647 ? 2147483647 : delay;

    // Display message
    this.timeout = setTimeout( () => {
      this.currentMessage = this.scheduledMessage;
      this.showNext();
    }, this.timeLeft);

    // this.setCurrentIndex();
  }

  private calcIntervalForMessage(message: {start_timestamp: number}) {
    let delay = 0;
    if (message) {
      const now = new Date();
      delay = message.start_timestamp - now.getTime();
      if (delay < 0) {
        delay = 0;
      }
    }
    return delay;
  }

  // setCurrentIndex() {
  //   if (this.currentMessage) {
  //     this.currentIndex = this.cachedMessages.map(message => {
  //       return message.id;
  //     }).indexOf(this.currentMessage.id);
  //   }
  // }

  currentIndex(): number {
    const emptyCurrent = {
      uuid: [
        { value: -1 }
      ]
    };
    const current = this.currentMessage || this.scheduledMessage || emptyCurrent;

    return this.cachedMessages.map(message => {
      return message.uuid[0].value;
    }).indexOf(current.uuid[0].value);
  }

  nextExists(): boolean {
    return this.currentIndex() < this.cachedMessages.length - 1;
  }

  public next() {
    const index = this.currentIndex();
    this.currentMessage = this.cachedMessages[index + 1];
    this.scheduledMessage = this.cachedMessages[index + 2];
  }

  public previous() {
    const index = this.currentIndex();
    this.currentMessage = this.cachedMessages[index - 1];
    this.scheduledMessage = this.cachedMessages[index];
  }

  public resume() {
    this.currentMessage = null;
    this.scheduledMessage = null;
    clearTimeout(this.timeout);
    this.messages = this.cachedMessages.slice();
    this.showNext();
  }

  showNotification(notifications) {
    // Clear any previous toast showing
    this.toastr.clear();

    const notification = notifications.pop();
    if (notification && notification !== 'void') {
      this.createNotification(notification);
    }

    // setTimeout(() => {
    //   notification = notifications.pop();
    //   if(notification && notification !== 'void') {
    //     this.toastr.info(notification, null, {
    //       timeOut: 30000,
    //       tapToDismiss: false
    //     });
    //   }
    // }, 500);
  }

  createNotification(notification) {
    this.toastr.info(notification, null, {
      timeOut: 0, // 30000,
      tapToDismiss: false
    });
  }

  onLoad(iframe) {
    console.log('Date: ', new Date());
    console.log('source: ', iframe.src);
  }

  findAndSetCurrentMessageById() {
    if (!this.posterIdInput) {
      return;
    }
    const foundMessage = this.cachedMessages.find(message => {
      return message.field_mt_ses_abstract_id[0].value.toLowerCase() === this.posterIdInput.toLowerCase();
    });

    this.currentMessage = foundMessage || this.currentMessage;
    this.scheduledMessage = this.cachedMessages[this.currentIndex() + 1];

    // Clear form field after search
    this.posterIdInput = '';
  }

  showVideoOverlay() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      videoUrl: 'https://www.youtube.com/embed/FlK95N8wqAA'
    };
    dialogConfig.width = '70vw';
    dialogConfig.height = '70vh';
    dialogConfig.maxWidth = '70vw';
    dialogConfig.maxHeight = '70vh';
    dialogConfig.panelClass = 'as-video-overlay';
    this.dialog.open(VideoOverlayComponent, dialogConfig);
  }
}
